<mat-form-field>
  <span
    [ngClass]="[currentCountry && currentCountry.alpha2 ? ('flag-icon-' + currentCountry.alpha2.toLowerCase()) : 'd-none']"
    class="pull-left centred-vertical selected-flag flag-icon flag"></span>
  <mat-select [formControl]="formControl"
              [placeholder]="'SELECT_YOUR_COUNTRY' | translate"
              (selectionChange)="onSelectionChanged()"
              [(ngModel)]="currentCountry"
              [tabIndex]="tabulatorIndex">
    <ngx-mat-select-search
      [formControl]="countryFilter"
      [placeholderLabel]="'SEARCH' | translate"
      clearSearchInput="true">
    </ngx-mat-select-search>
    <mat-option *ngFor="let country of filteredCountries | async" [value]="country">
      <div class="w-full over-hide text-ellipsis d-flex align-item-center">
        <span [ngClass]="['flag-icon-' + country.alpha2.toLowerCase()]"
              class="pull-left flag-icon flag centred-vertical"></span>
        <span class="pull-left p-l-1">{{country.name | translate}}</span>
      </div>
    </mat-option>
  </mat-select>
</mat-form-field>
